import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import PlacementTestRulerListContainer from './PlacementTestRulerListContainer';

const PlacementTestRulerListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Placement test rulers',
        },
      ]}
    />
    <Card
      title="Placement test rulers"
      actions={
        <Button
          type="primary"
          label="New placement test ruler"
          icon="plus"
          onClick={() => browserHistory.push('/placement-test-ruler/new')}
        />
      }
    >
      <PlacementTestRulerListContainer />
    </Card>
  </div>
);

export default PlacementTestRulerListScene;
